import { useState, useEffect } from 'react';
import { createProject, updateProject } from '../../utils/api';
import { useApp } from '../../context/AppContext';

const defaultForm = {
  title: '',
  description: '',
  category: 'general',
  priority: 'medium',
  status: 'idea',
  estimatedCost: '',
  estimatedDuration: '',
  targetDate: '',
  notes: '',
};

const ProjectForm = ({ existing, onClose }) => {
  const { fetchProjects } = useApp();
  const [form, setForm] = useState(defaultForm);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (existing) {
      setForm({
        ...existing,
        estimatedCost: existing.estimatedCost ?? '',
        targetDate: existing.targetDate?.slice(0, 10) ?? '',
      });
    }
  }, [existing]);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      if (existing) {
        await updateProject(existing._id, form);
      } else {
        await createProject(form);
      }
      await fetchProjects({ force: true });
      onClose();
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>{existing ? 'Edit Project' : 'New Project Idea'}</h2>
        <form onSubmit={handleSubmit} className="form">
          <label>Title *
            <input name="title" value={form.title} onChange={handleChange} required />
          </label>
          <label>Description
            <textarea name="description" value={form.description} onChange={handleChange} rows={2} />
          </label>
          <div className="form-row">
            <label>Category
              <select name="category" value={form.category} onChange={handleChange}>
                {['renovation', 'repair', 'upgrade', 'landscaping', 'seasonal', 'automotive', 'general'].map((c) => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </select>
            </label>
            <label>Priority
              <select name="priority" value={form.priority} onChange={handleChange}>
                {['low', 'medium', 'high'].map((p) => (
                  <option key={p} value={p}>{p}</option>
                ))}
              </select>
            </label>
            <label>Status
              <select name="status" value={form.status} onChange={handleChange}>
                {['idea', 'planned', 'in-progress', 'completed', 'on-hold'].map((s) => (
                  <option key={s} value={s}>{s}</option>
                ))}
              </select>
            </label>
          </div>
          <div className="form-row">
            <label>Estimated Cost ($)
              <input type="number" name="estimatedCost" value={form.estimatedCost} onChange={handleChange} min={0} />
            </label>
            <label>Estimated Duration
              <input name="estimatedDuration" value={form.estimatedDuration} onChange={handleChange} placeholder="e.g. 2 weekends" />
            </label>
          </div>
          <label>Target Date
            <input type="date" name="targetDate" value={form.targetDate} onChange={handleChange} />
          </label>
          <label>Notes
            <textarea name="notes" value={form.notes} onChange={handleChange} rows={2} />
          </label>
          <div className="form-actions">
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? 'Saving…' : 'Save'}
            </button>
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ProjectForm;
